export enum messageTypeEnum {
  ERROR = "error",
  WARNING = "advertissement",
  INFO = "info",
  SUCCESS = "success"
}
